import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({});
